import React, { useState } from 'react'
import { useEffect } from 'react'
import { connectStore } from 'redux-box';
import { module as newsFreeds } from 'store/newsFreeds'
import { module as ui } from 'store/ui'
import { Link } from "react-router-dom";
import NewsFreedsCard from "../news-freeds-list/news-freeds-card/NewsFreedsCard";
import {
    AlignContentHorizontal,CardIcon
} from "static/styled/custom.styled";

import Select from 'react-select'
import './news_sync.css'
import { ThemeButton } from '../../../static/styled/custom.styled';

let platformsList = [
    {
        label: 'CMS',
         value : 'CMS'
    },
    {
        label: 'CBSE',
         value : 'CBSE'
    },
    {
        label: 'Hello',
         value : 'Hello'
    },
]
const customStyles = {
    menu: (provided, state) => ({
        ...provided,
        position: "absolute",
    }),
    control: (provide) => ({
        ...provide,
        width: "95%",
        margin: "0 auto",
        border: "none",
        boxShadow: "none",
    }),
};

const NewsFreadSyncModal = ({ newsFreeds,ui }) => {

    const [platforms,setPlatforms] = useState([])
    const [selectedNews,setSelectedNews] = useState([])

    useEffect(() => {
        newsFreeds.requestNewsFreeds(true);
    }, [])

    const handleCardClicked = (news)=>{
        if(selectedNews.includes(news.id)){
            setSelectedNews(prev=>prev.filter((data)=>data !== news.id))
        }else{
            setSelectedNews(prev=>[...prev,news.id])
        }
    }

    const handleSyncNow = ()=>{
        let payload = {
            platforms: platforms.map((plt)=>plt.value),
            news_ids : selectedNews
        }
        newsFreeds.syncNewsToOtherPlatforms(payload)
        ui.hideModal()
    }

    return (
        <div className='news_sync_modal'>
            <p className='news_sync_modal_header'>Sync News to other platforms</p>
            <div className="news_sync_modal_cards">
                {
                    newsFreeds.news_freeds_list && newsFreeds.news_freeds_list.length > 0 ?
                        newsFreeds.news_freeds_list.map((news, index) => (
                            <div className="col-sm-6 col-md-4 col-lg-4" key={index} onClick={()=>handleCardClicked(news)}>
                                <NewsFreedsCard newsInfo={news} />
                                <CardIcon
                                    primary
                                    bg={selectedNews.includes(news.id)}
                                    className="news_card_tick_icon"
                                >
                                    <i className="fa fa-check" />
                                </CardIcon>
                            </div>
                        ))
                        : null
                }

            </div>
            <div className="platforms_list_container">
                <p className="platforms_list_title">
                    Select Platforms
                </p>

                <Select
                    className="dropdown-container news_sync_platform_select"
                    value={platforms}
                    onChange={(selectedSection) =>
                        setPlatforms(selectedSection)
                    }
                    options={platformsList}
                    placeholder="Select Platforms"
                    styles={customStyles}
                    menuPlacement="auto" // auto, top, or bottom
                    menuPosition="fixed"
                    isMulti={true}
                />
            </div>

            <ThemeButton primary onClick={handleSyncNow}>
                Sync Now
            </ThemeButton>
        </div>
    )
}

export default connectStore({
    newsFreeds, ui
})(NewsFreadSyncModal)